import React from "react";
import { View } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { FullscreenInput, TextInput } from "components";

import { styles } from "./styles";

const BaseValidatedInput = ({ hasError, rtl, ...props }) => {
  const edited = !!props.value?.length;
  return (
    <View
      style={[styles.textBox, { flexDirection: rtl ? "row-reverse" : "row" }]}
    >
      <TextInput
        placeholderTextColor={styles._textBox && styles._textBox.color}
        style={[styles.text]}
        {...props}
      />
      <View
        style={[
          styles.icon,
          edited && hasError && styles.invalid,
          edited && !hasError && styles.valid,
        ]}
      >
        {hasError !== undefined && edited && (
          <Icon name={hasError ? "times" : "check"} size={27} color="white" />
        )}
      </View>
    </View>
  );
};

export const ValidatedInput = props => (
  <FullscreenInput component={BaseValidatedInput} {...props} />
);
